// extracted by mini-css-extract-plugin
export default {"card-wrapper":"inapps_card-wrapper__794KP","card-block":"inapps_card-block__fhD7J","card-title":"inapps_card-title__FPsvR","sale-info-wrapper":"inapps_sale-info-wrapper__j5PVR"};